import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'

const  MerchForm1 = ({
  lineItemIndex,
  invoiceId,
  merchandiseId,
  invoiceIndex,
  isFormDisabled,
  saveData,
  updateData,
  fieldPattern,
  validateError
}) =>{

  const goodsDescription =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.goodsDescription) || ''
  const sku =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.sku) || ''

  const translate = React.useContext(TranslateContext).translate;
  const { lineItem } = fieldPattern()?.items
  const goodsDescriptionErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_goodsDescription`]) 
  const skuErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_sku`]) 

  return (
    <Grid.Row>
    <Grid.Column width={8} className='divFormFeild b-rw-0 b-tlr-5'>
      <InputField
        isLabel={false}
        id={`commercialDescription-${invoiceId}-${merchandiseId}`}
        type='text'
        label={translate("GOODS_DESCRIPTION", {ns:["default","lineItem"]})}
        value={goodsDescription}
        className='field-bg'
        errors={goodsDescriptionErr && goodsDescriptionErr?.msg}
        //invoice_1_lineItem2_goodsDescription
        disabled={isFormDisabled}
        onChange={(value) => updateData({goodsDescription:value})}
        onBlur={(value) =>{
          saveData({goodsDescription:goodsDescription || " "})
          const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_goodsDescription`
          validateError({[key]:""},{[key]:value},
            {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.goodsDescription}
          )
        }}
        
      />
    </Grid.Column>
    <Grid.Column width={8} className='divFormFeild  b-trr-5'>
      <InputField
        isLabel={false}
        id={`productTag-${invoiceId}-${merchandiseId}`}
        type='text'
        label='Sku'
        value={sku}
        errors={skuErr && skuErr?.msg}
        className='field-bg'
        onChange={(value) => updateData({'sku':value})}
        onBlur={(value) =>{
          saveData({sku:sku || " "})
          const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_sku`
          validateError({[key]:""},{[key]:value},
            {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.sku}
          )
        }}
      />
    </Grid.Column>
    </Grid.Row>
  )
}

export default MerchForm1
